import { useLocation, useNavigate } from "react-router-dom";
import "./BottomNav.css"; // Подключаем стили
import 'bootstrap-icons/font/bootstrap-icons.css';


const BottomNav = ({ toggleSearch, toggleFilter }) => {
  //console.log("BottomNav props:", { toggleSearch, toggleFilter });
  const location = useLocation();
  const navigate = useNavigate();

  const match = location.pathname.match(/\/courier\/routes\/(\d+)/);
  const routeId = match ? match[1] : null;

  const match2 = location.pathname.match(/\/courier\/receipts\/(\d+)/);
  const receiptId = match2 ? match2[1] : null;


  const buttonsConfig = {
    home: { label: "Главная", icon: <i className="bi bi-house" style={{ color: "rgb(0, 123, 255)" }}></i>, onClick: () => navigate("/") },
    search: { label: "Поиск", icon: <i className="bi bi-search" style={{ color: "rgb(0, 123, 255)" }}></i>, onClick: toggleSearch },
    filter: { label: "Фильтр", icon: <i className="bi bi-filter" style={{ color: "rgb(0, 123, 255)" }}></i>, onClick: toggleFilter },
    map: { label: "Карта", icon: <i className="bi bi-map" style={{ color: "rgb(0, 123, 255)" }}></i>, onClick: () => routeId && navigate(`/courier/routes/${routeId}/map`) },
    mapReceipt: { label: "На карте", icon: <i className="bi bi-map" style={{ color: "rgb(0, 123, 255)" }}></i>, onClick: () => receiptId && navigate(`/courier/receipts/${receiptId}/map`) },
    back: { label: "Назад", icon: <i className="bi bi-arrow-left" style={{ color: "rgb(0, 123, 255)" }}></i>, onClick: () => navigate(-1) },
    back_to_route: { label: "К листу", icon: <i className="bi bi-card-list" style={{ color: "rgb(0, 123, 255)" }}></i>, onClick: () => navigate(`/courier/routes/${routeId}`) },
    back_to_receipt: { label: "К квитанции", icon: <i className="bi bi-file-earmark-text" style={{ color: "rgb(0, 123, 255)" }}></i>, onClick: () => navigate(`/courier/receipts/${receiptId}`) },
    back_to_route3: { label: "Назад", icon: <i className="bi bi-arrow-left" style={{ color: "rgb(0, 123, 255)" }}></i>, onClick: () => navigate(`/courier/routes/${routeId}`) },
    settings: { label: "Настройки", icon: <i className="bi bi-gear" style={{ color: "rgb(0, 123, 255)" }}></i>, onClick: () => navigate("/users/settings") },
    users: { label: "Пользователи", icon: <i className="bi bi-people" style={{ color: "rgb(0, 123, 255)" }}></i>, onClick: () => navigate("/users") },
    routes: { label: "Маршруты", icon: <i className="bi bi-geo-alt" style={{ color: "rgb(0, 123, 255)" }}></i>, onClick: () => navigate("/courier/routes") },
    dashboard: { label: "Статистика", icon: <i className="bi bi-bar-chart" style={{ color: "rgb(0, 123, 255)" }}></i>, onClick: () => navigate("/dashboard") },
  };
  
  const menuConfig = {
    //Кнопки для домашней страницы
    "/": [ "back", "search", "home", "filter", "settings"],
    //Кнопки для Модуля Courier
    "/courier/routes": [ "back", "search", "home", "filter", "settings"],
    "/courier/routes/:id": [ "back", "search", "home", "filter", "map"],
    "/courier/receipts/:id": [ "back", "search", "home", "filter", "mapReceipt"],
    
    "/courier/products/:productId/marks/scan": ["back"],
    "/courier/routes/:id/map": [ "back", "search", "home", "filter", "back_to_route"],
    "/courier/receipts/:id/map": [ "back", "search", "home", "filter", "back"],
    "/users/settings": [ "back", "search", "home", "filter", "settings"],
    "/dashboard": ["home", "settings", "users", "routes", "dashboard"],
  };

  const currentPath = Object.keys(menuConfig).find((path) =>
    new RegExp(`^${path.replace(/:[^/]+/, "[^/]+")}$`).test(location.pathname)
  ) || "/";

  const buttons = menuConfig[currentPath].map((key) => buttonsConfig[key]);

  return (
    <div className="bottom-nav">
      {buttons.map((btn, index) => (
        <button key={index} onClick={btn.onClick}>
          <span className="icon">{btn.icon}</span>
          <span className="label">{btn.label}</span>
        </button>
      ))}
    </div>
  );
};

export default BottomNav;
